import { Cmd, CmdIface, CmdTypes, IntoLabelGenerator } from './command.model';
import { ChildConnector, ChildConnectorIface, ParentConnector, ParentConnectorIface } from './connection.model';
import { SlotName } from './query.model';

const cmdType: CmdTypes = 'SELECTDB';

interface SelectDbCmdProps {
  into: string;
  connection: string;
  select_db_clause_a: string;
  select_db_clause_b: string;
  where?: string;
  order_by?: string;
  has_limit: boolean;
  has_offset: boolean;
  limit?: Number;
  offset?: Number;
  group_by?: string;
}

interface SelectDbCmdState {
  node_type: CmdTypes;
  props: SelectDbCmdProps;
}

class SelectDbCmd extends Cmd implements CmdIface {
  private state: SelectDbCmdState;
  private intoConnector: ParentConnectorIface;

  constructor(state?: SelectDbCmdState) {
    super(cmdType);

    if (state) {
      this.state = state;
    } else {
      this.state = {
        node_type: cmdType,
        props: {
          into: IntoLabelGenerator(cmdType),
          connection: '',
          select_db_clause_a: '',
          select_db_clause_b: '',
          has_limit: false,
          has_offset: false,
        },
      };
    }
    super.SetNewProp(this.state.props);

    this.intoConnector = new ParentConnector(
      'OUTPUT1',
      '',
      () => this.state.props.into,
      (newLabel: string) => {
        this.state.props.into = newLabel;
      },
      () => {
        this.Slots['OUTPUT1'].isChecked = true;
      },
      () => {
        this.Slots['OUTPUT1'].isChecked = false;
      },
      this
    );
  }

  SetIntoLabel(newLabel: string) {
    if (this.intoConnector.IsConnected()) {
      this.intoConnector.SetIntoLabel(newLabel);
    } else {
      this.state.props.into = newLabel;
    }
  }

  GetInConnector(name: SlotName, label?: string): ChildConnectorIface {
    return null;
  }

  GetOutConnector(name: SlotName, label?: string): ParentConnectorIface {
    if (name === 'OUTPUT1') {
      return this.intoConnector;
    }
    return null;
  }

  OnCmdDelete(): void {
    if (this.intoConnector.IsConnected()) {
      this.intoConnector.Disconnect();
    }
  }
}

export { SelectDbCmdState, SelectDbCmd };
